import { useEffect } from 'react';
import { useState } from 'react';
import { useParams } from 'react-router';
import { Container } from 'react-bootstrap';
import { useAuth } from '../../components/general/ProvideAuth';
import { useHistory } from 'react-router';
import './Registry.css';
import  Breadcrumbs from '../../services/Breadcrumbs';
import API from '../../services/api';
import Pagination from '../../components/Pagination/Pagination';
import PaginationWrapper from '../../components/Pagination/PaginationWrapper';
import isFile from '../../lib/img/isFile.svg';
import  moment from 'moment';
import RegistrySearchBar from '../../components/SearchBar/RegistrySearchBar';
import {NormalizeDateView} from '../../services/NormalizeDateService';
import { 
  massagesFilter, 
  massagesErrorFilter,
  massagesErrorFilterNotFound
} from '../../services/messages';
import { pageSizeList } from '../../services/PageSize';

function Registry() {
  const [annulments, setAnnulments] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [dateFilterStart, setDateFilterStart] = useState(moment().startOf('year').format('DD.MM.YYYY'));
  const [dateFilterEnd, setDateFilterEnd] = useState(moment().format('DD.MM.YYYY'));
  const [searchRequests, setSearchRequests] = useState(null);
  const [searchNumberDoc, setSearchNumberDoc] = useState(null);
  const [errorFilterMessage, setErrorFilterMessage] = useState("");
  const [filterMessage, setFilterMessage] = useState("");
  const [styleRow, setStyleRow] = useState(null);
  const [sortRow, setSortRow] = useState("issued");
  const [Ask, setAsk] = useState(true);
  const { page } = useParams();
  const history = useHistory();
  const filds = ["Номер документа", "Код ЄДРПОУ", "Заявник", "Номер та дата дозволу", "Об'єкт благоустрою", "Адреса об’єкту"];
  const filds1 = "Номер документа";

  const auth = useAuth();

  const pathname = window.location.pathname; 
  const parts = pathname.split('/'); 
  const firstPart = parts[1]; 
  localStorage.setItem('localPath', "/"+firstPart);

  useEffect(() => {
    async function fetchData() {
      if (page =="doca") {
        history.push(`/dataSet-registry-annulments`);
      }
      const params = LocalStorageGet();
      if(params!== null){
        const start = params.dateStart;
        const end = params.dateEnd;
        const search = params.searchWords;
        await dataGet(start, end, search, searchNumberDoc);
      }else{
        await dataGet(dateFilterStart, dateFilterEnd);
      }
    }

    fetchData();
  }, [page,pageSize, Ask]);

  useEffect(()=>{
    if (window.location.href.includes("dataSet-registry-annulments")) {
      localStorage.removeItem('sortRef');
      localStorage.removeItem('sortIss');
      localStorage.removeItem('sortRefSelect');
      localStorage.removeItem('sortIssSelect');
      localStorage.removeItem('SortIsAskRefus');
      localStorage.removeItem('SortIsAskIssue');
      var sort = localStorage.getItem('sortAnul');
      var stlyeId = localStorage.getItem('sortAnulSelect');
      var isAsk = localStorage.getItem('SortIsAskAnul');
      if (isAsk === "true") {
        setAsk(true);
      } else {
        setAsk(false);
      }
      if(sort){
        var sortR = JSON.parse(sort);
        setSortRow(sortR);
      } else {
        setSortRow("issued");
      }
      if(stlyeId){
        var styleR = JSON.parse(stlyeId);
        setStyleRow(styleR);
      } else {
        setStyleRow(null);
      }
  } 
  }, []);

  const setSortLocalStor = (id)=>{
    var numbId = id;
    var sortR = sortRow;
    var isAsk = Ask;
    sortR = JSON.stringify(sortR);
    numbId = JSON.stringify(numbId);
    isAsk = JSON.stringify(isAsk);
    localStorage.setItem('sortAnul', sortR);
    localStorage.setItem('sortAnulSelect', numbId);
    localStorage.setItem('SortIsAskAnul', isAsk);
  };
  
  async function dataGet(dateFilterStart, dateFilterEnd, searchRequests, numberDoc) {
    const result = await API.get(`/annulment?SortField=${sortRow}`, {
      params: {
        page: page,
        pageSize: pageSize,
        dateStart: dateFilterStart,
        dateEnd: dateFilterEnd,
        searchWords: searchRequests,
        numberDoc: numberDoc,
        isAsk: Ask
      },
    }).then((res) => {
      setFilterMessage(massagesFilter(
        dateFilterStart,
        dateFilterEnd,
        searchRequests));
      setErrorFilterMessage("");
      if (res?.data) return res?.data;
      else return [];
    }).catch((error) => {
      if (error && (error?.response?.status && error?.response?.status == 404)) {
        setErrorFilterMessage(massagesErrorFilterNotFound());
      }else{
        setErrorFilterMessage(massagesErrorFilter());
      }
      setFilterMessage("");
      return [];
    });

    if (result && result.length > 0) {
      setAnnulments(result);
      
      const countResult = await API.get('/annulment/count', {
        params: {
          dateStart: dateFilterStart,
          dateEnd: dateFilterEnd,
          searchWords: searchRequests,
          numberDoc: numberDoc
        },
      });
      if (countResult.data) {
        setPageCount(Math.ceil(countResult.data.count / pageSize));
      }
    }else{
      setAnnulments([]);
      setPageCount(0);
    }

  };

  const handleSelect = (id) => {
    history.push(`/dataSet-registry-annulments/doca/${id}`);
  };

  const LocalStorage = (dataStart, dataEnd, search)=>{
    var params = {
           dateStart: dataStart,
           dateEnd: dataEnd,
           searchWords: search
     };
      params = JSON.stringify(params);
     localStorage.setItem('AnuluvannyaParams', params);
   };
 
   const LocalStorageGet =()=>{
     var paramsAnuluvannya = localStorage.getItem('AnuluvannyaParams');
     var params = JSON.parse(paramsAnuluvannya);
     return params;
   };

   const handleSubmitClear = async e => {
    localStorage.removeItem('AnuluvannyaParams');
    window.location.reload();
  };

  return (
    <div className="App">
      <Container className='mw-100'>
        <Breadcrumbs />
        <div className="d-flex flex-column">
          <div className="header-bar">
            <div className="header-text">
              <p>Анулювання</p>
            </div>
          </div>
          {RegistrySearchBar(dateFilterStart, setDateFilterStart,
                dateFilterEnd, setDateFilterEnd, errorFilterMessage, 
                filterMessage, setSearchRequests, searchRequests, filds, filds1, dataGet, LocalStorage, LocalStorageGet, setSearchNumberDoc, searchNumberDoc, handleSubmitClear)}
          <div className="mr-3 ml-3 my-2">
            <div className="my-2">
              <table className="table-responsive">
                <thead>
                  <tr>
                    {auth && auth.user? <th className="wd-th-small-3"><div className='column-th'>В</div></th>:<></> }
                    <th className="wd-th-small"><div className='column-th thStyleSort' onClick={()=>{setSortRow("number"); setAsk(!Ask);}}><span className={sortRow === "number" ? "orangeStR" : "noneStR"}>{!Ask? "↓":"↑" }</span> Номер документа </div></th>
                    <th className="wd-th-small"><div className='column-th thStyleSort' onClick={()=>{setSortRow("issued"); setAsk(!Ask);}}><span className={sortRow === "issued" ? "orangeStR" : "noneStR"}>{Ask? "↑": "↓"}</span> Дата документа</div></th>
                    <th className="wd-th-small"><div className='column-th'>Код ЄДРПОУ</div></th>
                    <th className="wd-th-middle"><div className='column-th'>Заявник<br/></div></th>
                    <th className="wd-th-big-vh10"><div className='column-th'>Вид робіт<br/></div></th>
                    <th className="wd-th-big-vh6"><div className='column-th'>Адреса об’єкту</div></th>
                    <th className="wd-th-small"><div className='column-th'>Район робіт</div></th>
                    <th className="wd-th-middle"><div className='column-th'>Номер та дата дозволу</div></th>
                  </tr>
                </thead>
                <tbody>
                  {annulments.map((a) => (
                      <tr key={a.id} className={styleRow === a.id ? 'hoverStyleIssuaces selectedRow' : 'hoverStyleIssuaces'} onClick={()=>{setStyleRow(a.id);}}>
                      {auth && auth.user? <td> {a.existsFile == true && <img src={isFile} height="24px" width="24px"/>} </td>:<></> }
                      <td className="registry-item-click"  onClick={() =>{setSortLocalStor(a.id);handleSelect(a.parentDocument)}}>{a.number}</td>
                      <td>{NormalizeDateView(a.issued)}</td>
                      <td>{a.applicantIdentifier}</td>
                      <td>{a.applicantName}</td>
                      <td>{a.type}</td>
                      <td>{a.addressDescription}</td>
                      <td>{a.addressAdminUnit}</td>
                      <td>{a.priorPermit}</td>
                    </tr>
                  ))}
                </tbody>
                {/* <tr><td>9 </td><td>899225-2022 </td><td>21.10.2022 14:30:36 </td><td>Надання адміністративних послуг </td><td>120-17 </td><td>Надання консультацій (ГАРЯЧА ЛІНІЯ) </td></tr><tr><td>10 </td><td>899219-2022 </td><td>21.10.2022 14:29:21 </td><td>Оформлення паспортів </td><td>120-17 </td><td>Надання консультацій (ГАРЯЧА ЛІНІЯ) </td>
                </tr>
                <tr><td>12 </td><td>899213-2022 </td><td>21.10.2022 14:27:55 </td><td>Надання адміністративних послуг </td><td>120-17 </td><td>Надання консультацій (ГАРЯЧА ЛІНІЯ) </td>
                </tr>
                <tr><td>13 </td><td>899164-2022 </td><td>21.10.2022 14:09:19 </td><td>Надання адміністративних послуг </td><td>120-17 </td><td>Надання консультацій (ГАРЯЧА ЛІНІЯ) </td>
                </tr> */}
              </table>
              {PaginationWrapper(page, pageCount, "/dataSet-registry-annulments/", pageSizeList, setPageSize)}
              {/* <div className="paginator"><span><a href="/dataSet-8c6bcb69-7277-4c25-9035-23fca627f08c/1" className="active">1</a></span><span><a href="/dataSet-8c6bcb69-7277-4c25-9035-23fca627f08c/2">2</a></span><span><a href="/dataSet-8c6bcb69-7277-4c25-9035-23fca627f08c/3">3</a></span><span><a href="/dataSet-8c6bcb69-7277-4c25-9035-23fca627f08c/4">4</a></span><span>...<a href="/dataSet-8c6bcb69-7277-4c25-9035-23fca627f08c/722">722</a></span><span><a href="/dataSet-8c6bcb69-7277-4c25-9035-23fca627f08c/723">723</a></span><span><a href="/dataSet-8c6bcb69-7277-4c25-9035-23fca627f08c/724">724</a></span></div> */}
            </div>
          </div>
        </div>
      </Container>
    </div>

  );

}

export default Registry;
